import Vue from 'vue'

/* Alias Component */
Vue.component("VValidate", () => import("@/components/VValidate.vue"))